<template>
  <div style="padding-left: 40px">
    <header>
      <!-- <div class="tabs">
        <div>固定模块</div>
        <div>自定义模块</div>
      </div> -->
      <div class="header_right">
        <el-button type="text">装修预览</el-button>
        <el-button type="text">保存为草稿</el-button>
        <el-button type="primary" @click="submit">发布店铺装修</el-button>
      </div>
    </header>
    <div class="banner">
      <el-checkbox v-model="checkList.banner">banner</el-checkbox>
      <div class="img_box" v-for="(item, index) in imagesList" :key="index">
        <img :src="item" alt="" />
      </div>
      <el-button
        type="text"
        @click="handleUploadImages(1)"
        style="margin-left: 40px"
        >上传</el-button
      >
    </div>
    <div class="good_class">
      <div class="title">
        <el-checkbox v-model="checkList.classGood">店内分类</el-checkbox>
        <span>（选择后可设置店铺内自己商品分类）</span>
        <!-- <span>（选择后可在店铺首页展示店内销量排名在前五的商品）</span> -->
      </div>
      <div v-if="checkList.classGood">
        <div
          class="fenlei_item"
          v-for="(item, index) in classList"
          :key="index"
        >
          <div class="fenlei_tit">
            <p>分类{{ index + 1 }}</p>
          </div>
          <div class="fenlei_content">
            <el-form>
              <div><div class="tit">名称</div></div>
              <div>
                <el-form-item>
                  <el-input v-model="item.name" style="width: 400px"></el-input>
                </el-form-item>
              </div>
            </el-form>
            <div class="imgList">
              <span> logo </span>
              <div class="logoBox">
                <img :src="item.logo" alt="" />
              </div>
              <p @click="handleUploadImages(2, index)">上传</p>
            </div>
            <el-form>
              <div><div class="tit">商品</div></div>
              <div>
                <el-form-item v-for="(good, i) in item.goodList" :key="i">
                  <el-input v-model="good.goodName" style="width: 400px">
                    <el-button slot="append" @click="selectGood(index, i, 1)"
                      >选择商品</el-button
                    >
                  </el-input>
                </el-form-item>
                <el-button
                  type="primary"
                  style="width: 200px"
                  @click="addClassGood(index)"
                  >添加分类 - 商品</el-button
                >
              </div>
            </el-form>
          </div>
        </div>
        <el-button
          type="primary"
          style="width: 200px; margin: 20px 40px"
          @click="addClass"
          >添加分类</el-button
        >
      </div>
    </div>
    <div class="good_class">
      <div class="title">
        <el-checkbox v-model="checkList.top">销售top榜</el-checkbox>
        <span>（选择后可在店铺首页展示店内销量排名在前五的商品）</span>
      </div>
      <div class="goodBox" v-if="checkList.top">
        <div class="good" v-for="(sale,saleIndex) in goodSaleList" :key="saleIndex">
          <div class="imgBox">
            <img :src="sale.logo" alt="" />
          </div>
          <div id="text">{{sale.goodName}}</div>
        </div>
      </div>
    </div>
    <div class="good_class">
      <div class="title">
        <el-checkbox v-model="checkList.seckill">秒杀活动</el-checkbox>
        <span>（选择后可在店铺首页展示进行中的秒杀活动商品,最多展示6个）</span>
      </div>
      <div class="goodBox" v-if="checkList.seckill">
        <div class="good" v-for="(sale,saleIndex) in seckillList" :key="saleIndex">
          <div class="imgBox">
            <img :src="sale.logo" alt="" />
          </div>
          <div class="text">{{sale.goodName}}</div>
        </div>
      </div>
    </div>
    <div class="good_class">
      <div class="title">
        <el-checkbox v-model="checkList.presell">预售活动</el-checkbox>
        <span>（选择后可在店铺首页展示进行中的预售活动商品,最多展示6个）</span>
      </div>
      <div class="goodBox" v-if="checkList.presell">
        <div class="good" v-for="(sale,saleIndex) in goodPresaleList" :key="saleIndex">
          <div class="imgBox">
            <img :src="sale.logo" alt="" />
          </div>
          <div class="text">{{sale.goodName}}</div>
        </div>
      </div>
    </div>
    <div class="good_class">
      <div class="title">
        <el-checkbox v-model="checkList.recommend">推荐商品</el-checkbox>
        <span>（可选择店铺推荐商品展示在店铺首页）</span>
      </div>
      <div class="recommend" v-if="checkList.recommend">
        <el-form>
          <div><div class="tit">商品</div></div>
          <div>
            <el-form-item v-for="(good, i) in recommendList" :key="i">
              <el-input v-model="good.name" style="width: 400px">
                <el-button slot="append" @click="selectGood(i, 1, 2)"
                  >选择商品</el-button
                >
              </el-input>
            </el-form-item>
            <el-button
              type="primary"
              style="width: 200px" 
              @click="addRecommend()"
              >添加推荐商品</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
    <el-dialog
      title="选择商品"
      :visible.sync="centerDialogVisible"
      width="60%"
      center
    >
      <div style="margin: 20px 0">
        <el-input
          style="width: 300px"
          placeholder="请输入商品名称\编码"
          maxlength="30"
          v-model="searchValue"
        ></el-input>
        <el-button type="primary" @click="getGoodList(1)">搜索</el-button>
        <el-button type="info" @click="reset">重置</el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%">``
        <el-table-column
          align="center"
          prop="goodName"
          label="商品名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="price"
          label="售价"
          width="180"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="stock"
          label="库存"
          width="180"
        ></el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addsgood(scope.row)"
              >选择商品</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageFn()"
        layout="prev, pager, next"
        :current-page.sync="currentPage"
        :page-size="10"
        :total="goodsCount"
      ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDecoration, setDecoration } from "@/api/manageMems";
import { mapGetters } from "vuex";
import A from "../../assets/upload";
import { getUploadToken, getSeckillGood, getUploadId } from "@/api/goods";
export default {
  mixins: [A],
  data() {
    return {
      classList: [],
      name: "123",
      checked: true,
      imagesList: [],
      checkList: {
        banner: false,
        classGood: false,
        top: false,
        seckill: false,
        presell: false,
        recommend: false,
      },
      centerDialogVisible: false,
      currentPage: 1,
      goodsCount: 10,
      searchValue: "",
      tableData: [],
      index: "",
      goodIndex: "",
      recommendList: [{ name: "", id: "" }],
      imgIndex: "",
      type: "",
      recommendIndex: "",
      goodSaleList:[],// 销售top榜商品列表
      goodPresaleList:[],// 预售商品列表
      seckillList:[],
    };
  },
  mounted() {
    this.getData();
    this.$on("upload-finish", (data) => {
      let { isupdate } = data;
      // console.log(data);
      if (!data) return;
      if (isupdate == 2) {
        console.log(this.imgIndex);
        this.classList[this.imgIndex].logo = data.src;
      } else {
        if (this.imagesList.length > 4) {
          this.$message("最多上传5张图");
          return;
        }
        this.imagesList.push(data.src);
        this.imagesList = this.order2(this.imagesList);
      }
    });
  },
  computed: {
    ...mapGetters(["chooseCompany", "companyList", "mchId"]),
  },
  methods: {
    getData() {
      getDecoration(this.chooseCompany.id)
        .then((res) => {
          console.log(res);
          this.goodSaleList = res.data.goodSaleList.slice(0,5);
          this.goodPresaleList = res.data.goodPresaleList.slice(0,6);
          this.seckillList = res.data.seckillList.slice(0,6);
        })
        .catch((err) => {});
    },
    // 选择商品
    selectGood(index, i, type) {
      this.type = type;
      if (type == 1) {
        this.index = index;
        this.goodIndex = i;
        this.centerDialogVisible = true;
        this.getGoodList();
      } else {
        this.recommendIndex = index;
        this.centerDialogVisible = true;
        this.getGoodList();
      }
    },
    getGoodList(page) {
      let mchId = this.chooseCompany.id;
      let data = {
        pageCount: 10,
        page: this.currentPage,
        goodName: this.searchValue,
        mchId: mchId,
      };
      if (page) {
        console.log(1);
        data.page = page;
      }
      getSeckillGood(data).then((res) => {
        let count = res.data.pop();
        if (typeof count != "undefined") {
          this.goodsCount = count.goodsCount;
        }
        this.tableData = res.data;
      });
    },
    pageFn() {
      this.getGoodList();
    },
    reset() {
      this.searchValue = "";
      this.getGoodList();
    },
    addClass() {
      if (this.classList.length < 10) {
        this.classList.push({
          name: "",
          logo: "",
          goodList: [{ goodId: "", goodName: "" }],
        });
      } else {
      }
    },
    addClassGood(i) {
      this.classList[i].goodList.push({ goodId: "", goodName: "" });
    },
    addsgood(data) {
      if (this.type == 1) {
        let swit = true;
        this.classList[this.index].goodList.forEach((item) => {
          data.goodId == item.goodId ? (swit = false) : console.log(swit);
        });
        if (swit) {
          let good = {
            name: data.goodName,
            id: data.goodId,
          };
          this.classList[this.index].goodList[this.goodIndex].goodId =
            data.goodId;
          this.classList[this.index].goodList[this.goodIndex].goodName =
            data.goodName;
          this.centerDialogVisible = false;
        } else {
          this.$message("已添加该商品");
        }
      } else {
        let swit = true;
        this.recommendList.forEach((item) => {
          data.goodId == item.id ? (swit = false) : console.log(swit);
        });
        if (swit) {
          let good = {
            name: data.goodName,
            id: data.goodId,
          };
          this.recommendList[this.recommendIndex].id = data.goodId;
          this.recommendList[this.recommendIndex].name = data.goodName;
          this.centerDialogVisible = false;
        } else {
          this.$message("已添加该商品");
        }
      }
    },
    handleUploadImages(index, i) {
      this.imgIndex = i;

      if (index == 1) {
        if (this.imagesList.length >= 5) {
          this.$message("最多上传5张图");
          return;
        }
      }
      let option = {
        multiple: !0,
        params: {
          isupdate: index,
          region: "ap-beijing",
          bucket: " ",
          previewUrl: "https://cdn.shop.rangepark.cn",
        },
        getFileId: getUploadId,
        getAuthFunction: getUploadToken,
        accept: "image/*",
      };
      this.handleClickUpload(option);
    },
    order2(words) {
      var correlation = [],
        reorder = [];
      if (words === "") {
        return words;
      }
      words.forEach((item, index) => {
        correlation[index] = {};
        correlation[index]["i"] = index;
        let number = "";
        if (item.indexOf("/") > 0) {
          //如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
          let filename = "";
          filename = item.substring(item.lastIndexOf("/") + 1, item.length);
          number = filename.substring(0, filename.indexOf("."));
        }
        correlation[index]["v"] = Number(number);
      });
      correlation.sort((a, b) => {
        return a.v - b.v;
      });
      correlation.forEach((item, index) => {
        reorder.push(words[item.i]);
      });
      return reorder;
    },
    //添加推荐商品
    addRecommend() {
      this.recommendList.push({ name: "", id: "" });
    },
    submit() {
      let types = [];
      this.classList.forEach((item) => {
        let data = [];
        for (let i = 0; i < item.goodList.length; i++) {
          data.push(item.goodList[i].goodId);
        }
        types.push({
          goodIds: data,
          logo: item.logo,
          type: item.name,
        });
      });
      let recommendGoodIds = [];
      this.recommendList.forEach((item) => {
        recommendGoodIds.push(item.id);
      });
      let data = {
        banners: this.imagesList,
        mchId: this.chooseCompany.id,
        recommendGoodIds: recommendGoodIds,
        showPresale: this.checkList.presell ? 1 : 0,
        showRecommend: this.checkList.recommend ? 1 : 0,
        showSeckill: this.checkList.seckill ? 1 : 0,
        showTop: this.checkList.top ? 1 : 0,
        showBanner: this.checkList.banner ? 1 : 0,
        showType: this.checkList.classGood ? 1 : 0,
        types,
      };
      console.log(data);
      setDecoration(data)
        .then((res) => {
          this.$message({
            message: "发布成功",
            type: "success",
          });
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss">
header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .tabs {
    display: flex;
    div {
      width: 250px;
      height: 50px;
      border: #eee solid 1px;
      text-align: center;
      line-height: 50px;
      font-size: 14px;
      margin-right: 20px;
      cursor: pointer;
    }
  }
  .header_right {
    margin-right: 50px;
  }
}
.banner {
  height: 100px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  .img_box {
    width: 100px;
    height: 60px;
    margin: 0 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.good_class {
  // height: 150px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  // align-items: center;
  .title {
    span {
      color: gray;
    }
  }
  .fenlei_item {
    display: flex;
    margin: 20px 40px;
    font-size: 14px;
    // align-items:center

    .fenlei_tit {
      p {
        width: 60px;
        height: 40px;
        background-color: #eee;
        text-align: center;
        line-height: 40px;
        margin: 0;
        margin-right: 30px;
      }
    }
    .fenlei_content {
      width: 800px;
      .imgList {
        margin: 20px 0;
        margin-top: 0;
        height: 50px;
        // width: 50px;
        display: flex;
        align-items: center;

        .logoBox {
          width: 50px;
          height: 50px;
          margin-left: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        p {
          cursor: pointer;
          color: #66b1ff;
          margin-left: 20px;
        }
      }
      .el-form {
        display: flex;
        .tit {
          height: 40px;
          text-align: center;
          line-height: 40px;
          margin-right: 20px;
        }
      }
    }
  }

  .goodBox {
    display: flex;
    .good {
      margin: 20px;
      width: 90px;
      height: 110px;
      padding: 8px;
      overflow: hidden;
      background-color: #eee;
      // display:flex;
      // flex-direction:column;

      .imgBox {
        width: 90px;
        height: 50px;
        margin-bottom: 5px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      #text {
        // height: 50px;
        // line-height: 25px;
        // font-size: 14px;
        // overflow: hidden;
        
      }
      .text{
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}
.recommend {
  padding: 20px 40px;
  .el-form {
    display: flex;
    .tit {
      height: 40px;
      text-align: center;
      line-height: 40px;
      margin-right: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/shopManage/decoration.vue